export default {
      id: "icon-expert-usage",
      viewBox: "0 0 26 25",
      url: __webpack_public_path__ + "icons.svg#icon-expert",
      toString: function () {
        return this.url;
      }
    }